/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AlertRuleDTO
 */
export interface AlertRuleDTO {
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleDTO
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'priority'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'minDiscountVsMarketValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'minDiscountVsWineSearcher'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'minDiscountVsLastTransaction'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'maxPriceAbsolute'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'minPriceAbsolute'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'minCriticScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'preferredCritics'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleDTO
     */
    'requireCriticReview'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'drinkingWindowMinYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'drinkingWindowMaxYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'acceptedMaturities'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'regions'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'producers'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'nameContains'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'classifications'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'minVintage'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'maxVintage'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleDTO
     */
    'biddingOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'maxBidToValueRatio'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleDTO
     */
    'noBidsOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleDTO
     */
    'alertOnNewListings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleDTO
     */
    'alertOnPriceDrop'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleDTO
     */
    'alertOnRevaluation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'minPriceDropPct'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleDTO
     */
    'lastTriggered'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleDTO
     */
    'triggerCount'?: number;
}
/**
 * 
 * @export
 * @interface AlertRuleRequest
 */
export interface AlertRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof AlertRuleRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleRequest
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'priority'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'minDiscountVsMarketValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'minDiscountVsWineSearcher'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'minDiscountVsLastTransaction'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'maxPriceAbsolute'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'minPriceAbsolute'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'minCriticScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleRequest
     */
    'preferredCritics'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleRequest
     */
    'requireCriticReview'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'drinkingWindowMinYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'drinkingWindowMaxYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleRequest
     */
    'acceptedMaturities'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleRequest
     */
    'regions'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleRequest
     */
    'producers'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleRequest
     */
    'nameContains'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertRuleRequest
     */
    'classifications'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'minVintage'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'maxVintage'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleRequest
     */
    'biddingOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'maxBidToValueRatio'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleRequest
     */
    'noBidsOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleRequest
     */
    'alertOnNewListings'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleRequest
     */
    'alertOnPriceDrop'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AlertRuleRequest
     */
    'alertOnRevaluation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlertRuleRequest
     */
    'minPriceDropPct'?: number;
}
/**
 * 
 * @export
 * @interface AlertStatusUpdateRequest
 */
export interface AlertStatusUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AlertStatusUpdateRequest
     */
    'status'?: AlertStatusUpdateRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AlertStatusUpdateRequest
     */
    'notes'?: string;
}

export const AlertStatusUpdateRequestStatusEnum = {
    New: 'NEW',
    Reviewed: 'REVIEWED',
    Dismissed: 'DISMISSED',
    Interesting: 'INTERESTING',
    Purchased: 'PURCHASED'
} as const;

export type AlertStatusUpdateRequestStatusEnum = typeof AlertStatusUpdateRequestStatusEnum[keyof typeof AlertStatusUpdateRequestStatusEnum];

/**
 * 
 * @export
 * @interface BulkAlertStatusUpdateRequest
 */
export interface BulkAlertStatusUpdateRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkAlertStatusUpdateRequest
     */
    'alertIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof BulkAlertStatusUpdateRequest
     */
    'status'?: BulkAlertStatusUpdateRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkAlertStatusUpdateRequest
     */
    'notes'?: string;
}

export const BulkAlertStatusUpdateRequestStatusEnum = {
    New: 'NEW',
    Reviewed: 'REVIEWED',
    Dismissed: 'DISMISSED',
    Interesting: 'INTERESTING',
    Purchased: 'PURCHASED'
} as const;

export type BulkAlertStatusUpdateRequestStatusEnum = typeof BulkAlertStatusUpdateRequestStatusEnum[keyof typeof BulkAlertStatusUpdateRequestStatusEnum];

/**
 * 
 * @export
 * @interface DataSource
 */
export interface DataSource {
    /**
     * 
     * @type {number}
     * @memberof DataSource
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'apiUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'apiKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataSource
     */
    'pollIntervalMinutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'lastPollTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'nextScheduledPoll'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DataSource
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataSource
     */
    'autoImportEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataSource
     */
    'totalProductsImported'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataSource
     */
    'totalListingsImported'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'lastImportStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'lastImportError'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSource
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ImportSession>}
     * @memberof DataSource
     */
    'importSessions'?: Array<ImportSession>;
    /**
     * 
     * @type {ImportSummary}
     * @memberof DataSource
     */
    'latestImportSummary'?: ImportSummary;
    /**
     * 
     * @type {boolean}
     * @memberof DataSource
     */
    'importRunning'?: boolean;
    /**
     * 
     * @type {ImportSession}
     * @memberof DataSource
     */
    'latestImportSession'?: ImportSession;
    /**
     * 
     * @type {ImportSession}
     * @memberof DataSource
     */
    'runningImportSession'?: ImportSession;
}
/**
 * 
 * @export
 * @interface DataSourceCreateRequest
 */
export interface DataSourceCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof DataSourceCreateRequest
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceCreateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceCreateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceCreateRequest
     */
    'apiUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceCreateRequest
     */
    'apiKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataSourceCreateRequest
     */
    'pollIntervalMinutes'?: number;
}
/**
 * 
 * @export
 * @interface DataSourceUpdateRequest
 */
export interface DataSourceUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof DataSourceUpdateRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceUpdateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceUpdateRequest
     */
    'apiUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DataSourceUpdateRequest
     */
    'apiKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof DataSourceUpdateRequest
     */
    'pollIntervalMinutes'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DataSourceUpdateRequest
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DataSourceUpdateRequest
     */
    'autoImportEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ImportConfigRequest
 */
export interface ImportConfigRequest {
    /**
     * Include product details (drinking windows and critic reviews). Smart enrichment: only fetches details for new or changed vintages. Set to false only if ProductDetails API is unavailable. Existing data will be preserved when disabled.
     * @type {boolean}
     * @memberof ImportConfigRequest
     */
    'includeProductDetails'?: boolean;
}
/**
 * 
 * @export
 * @interface ImportSession
 */
export interface ImportSession {
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'id'?: number;
    /**
     * 
     * @type {DataSource}
     * @memberof ImportSession
     */
    'dataSource'?: DataSource;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    'endTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    'status'?: ImportSessionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    'importConfig'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'newProductsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'modifiedProductsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'newVintagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'modifiedVintagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'newSkusCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'modifiedSkusCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'newListingsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'modifiedListingsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'deletedListingsCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'processingErrorCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'enrichmentErrorCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'truncatedSliceCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'lwinConflictCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapImportedCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapPhantomCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapEventFilteredCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapNewProductsCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapModifiedProductsCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapNewVintagesCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapModifiedVintagesCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapNewSkusCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapModifiedSkusCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapNewListingsCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapModifiedListingsCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'gapDeletedListingsCount'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSession
     */
    'totalProcessingTimeMs'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'totalPagesProcessed'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'totalProductsProcessed'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSession
     */
    'durationInSeconds'?: number;
    /**
     * 
     * @type {ImportSummary}
     * @memberof ImportSession
     */
    'summary'?: ImportSummary;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    'dataSourceCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportSession
     */
    'dataSourceName'?: string;
}

export const ImportSessionStatusEnum = {
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type ImportSessionStatusEnum = typeof ImportSessionStatusEnum[keyof typeof ImportSessionStatusEnum];

/**
 * 
 * @export
 * @interface ImportSummary
 */
export interface ImportSummary {
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'newProducts'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'modifiedProducts'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'newVintages'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'modifiedVintages'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'newSkus'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'modifiedSkus'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'newListings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'modifiedListings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportSummary
     */
    'deletedListings'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSummary
     */
    'processingErrors'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSummary
     */
    'enrichmentErrors'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSummary
     */
    'truncatedSlices'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSummary
     */
    'lwinConflicts'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSummary
     */
    'gapImported'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSummary
     */
    'gapPhantoms'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSummary
     */
    'gapEventsFiltered'?: number;
    /**
     *
     * @type {number}
     * @memberof ImportSummary
     */
    'totalChanges'?: number;
}
/**
 * 
 * @export
 * @interface LinkLwinRequest
 */
export interface LinkLwinRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkLwinRequest
     */
    'lwin'?: number;
}
/**
 * 
 * @export
 * @interface LinkLwinResponse
 */
export interface LinkLwinResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LinkLwinResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkLwinResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface LwinMappingCandidate
 */
export interface LwinMappingCandidate {
    /**
     * 
     * @type {LwinReference}
     * @memberof LwinMappingCandidate
     */
    'lwinReference'?: LwinReference;
    /**
     * 
     * @type {number}
     * @memberof LwinMappingCandidate
     */
    'confidence'?: number;
    /**
     * 
     * @type {MatchDetails}
     * @memberof LwinMappingCandidate
     */
    'matchDetails'?: MatchDetails;
    /**
     * 
     * @type {boolean}
     * @memberof LwinMappingCandidate
     */
    'eligibleForAutoLink'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LwinMappingCandidate
     */
    'autoLinkDeclineReason'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LwinMappingCandidate
     */
    'fieldEligibility'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface LwinReference
 */
export interface LwinReference {
    /**
     * 
     * @type {number}
     * @memberof LwinReference
     */
    'lwin'?: number;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'producerTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'producerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'wine'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'subRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'site'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'parcel'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'colour'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'subType'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'designation'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'classification'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'vintageConfig'?: string;
    /**
     * 
     * @type {number}
     * @memberof LwinReference
     */
    'firstVintage'?: number;
    /**
     * 
     * @type {number}
     * @memberof LwinReference
     */
    'finalVintage'?: number;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'dateAdded'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'dateUpdated'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof LwinReference
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface LwinReferenceFilterValues
 */
export interface LwinReferenceFilterValues {
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'statuses'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'producerNames'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'countries'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'regions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'subRegions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'colours'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'types'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'subTypes'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'classifications'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LwinReferenceFilterValues
     */
    'vintageConfigs'?: Array<string>;
}
/**
 * 
 * @export
 * @interface MasterProduct
 */
export interface MasterProduct {
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'masterProductId'?: string;
    /**
     * 
     * @type {LwinReference}
     * @memberof MasterProduct
     */
    'lwinReference'?: LwinReference;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'producer'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'subRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'colour'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'category'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MasterProduct
     */
    'bbrOwnSelection'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProduct
     */
    'lastUpdated'?: string;
    /**
     * 
     * @type {Set<SourceProduct>}
     * @memberof MasterProduct
     */
    'sourceProducts'?: Set<SourceProduct>;
    /**
     * 
     * @type {Set<MasterProductVintage>}
     * @memberof MasterProduct
     */
    'vintages'?: Set<MasterProductVintage>;
}
/**
 * 
 * @export
 * @interface MasterProductFilterValues
 */
export interface MasterProductFilterValues {
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterProductFilterValues
     */
    'categories'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterProductFilterValues
     */
    'colours'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterProductFilterValues
     */
    'countries'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterProductFilterValues
     */
    'regions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterProductFilterValues
     */
    'subRegions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MasterProductFilterValues
     */
    'producers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface MasterProductVintage
 */
export interface MasterProductVintage {
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintage
     */
    'masterProductVintageId'?: string;
    /**
     * 
     * @type {MasterProduct}
     * @memberof MasterProductVintage
     */
    'masterProduct'?: MasterProduct;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintage
     */
    'vintage'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintage
     */
    'maturity'?: MasterProductVintageMaturityEnum;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintage
     */
    'sourceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintage
     */
    'expertReview'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintage
     */
    'alcoholPercentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintage
     */
    'grapeVarieties'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintage
     */
    'sweetness'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintage
     */
    'drinkingFromYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintage
     */
    'drinkingToYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintage
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintage
     */
    'lastUpdated'?: string;
    /**
     * 
     * @type {Set<SourceProductVintage>}
     * @memberof MasterProductVintage
     */
    'sourceVintages'?: Set<SourceProductVintage>;
    /**
     * 
     * @type {Set<MasterProductVintageCriticReview>}
     * @memberof MasterProductVintage
     */
    'criticReviews'?: Set<MasterProductVintageCriticReview>;
    /**
     * 
     * @type {Set<MasterProductVintageSku>}
     * @memberof MasterProductVintage
     */
    'productVintageSkus'?: Set<MasterProductVintageSku>;
}

export const MasterProductVintageMaturityEnum = {
    Unknown: 'UNKNOWN',
    NotReady: 'NOT_READY',
    ReadyYoung: 'READY_YOUNG',
    ReadyAtBest: 'READY_AT_BEST',
    ReadyMature: 'READY_MATURE'
} as const;

export type MasterProductVintageMaturityEnum = typeof MasterProductVintageMaturityEnum[keyof typeof MasterProductVintageMaturityEnum];

/**
 * 
 * @export
 * @interface MasterProductVintageCriticReview
 */
export interface MasterProductVintageCriticReview {
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageCriticReview
     */
    'reviewId'?: string;
    /**
     * 
     * @type {MasterProductVintage}
     * @memberof MasterProductVintageCriticReview
     */
    'masterProductVintage'?: MasterProductVintage;
    /**
     * 
     * @type {WineCritic}
     * @memberof MasterProductVintageCriticReview
     */
    'wineCritic'?: WineCritic;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageCriticReview
     */
    'score'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageCriticReview
     */
    'reviewDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageCriticReview
     */
    'reviewText'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageCriticReview
     */
    'drinkingFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageCriticReview
     */
    'drinkingTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageCriticReview
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageCriticReview
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface MasterProductVintageSku
 */
export interface MasterProductVintageSku {
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'masterSkuId'?: string;
    /**
     * 
     * @type {MasterProductVintage}
     * @memberof MasterProductVintageSku
     */
    'masterProductVintage'?: MasterProductVintage;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'canonicalSkuCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'lwin16'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSku
     */
    'bottleSizeMl'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSku
     */
    'caseSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSku
     */
    'adjustedMarketPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'adjustedMarketPriceUpdateDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSku
     */
    'lastTransaction'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'lastTransactionUpdateDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSku
     */
    'highestBid'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'highestBidUpdateDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSku
     */
    'leastListingPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'leastListingPriceUpdateDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSku
     */
    'wineSearcherPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'wineSearcherPriceUpdateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSku
     */
    'lastUpdated'?: string;
    /**
     * 
     * @type {Set<SourceProductVintageSku>}
     * @memberof MasterProductVintageSku
     */
    'sourceSkus'?: Set<SourceProductVintageSku>;
    /**
     * 
     * @type {Set<MasterProductVintageSkuListing>}
     * @memberof MasterProductVintageSku
     */
    'productVintageSkuListings'?: Set<MasterProductVintageSkuListing>;
}
/**
 * 
 * @export
 * @interface MasterProductVintageSkuListing
 */
export interface MasterProductVintageSkuListing {
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'skuListingId'?: string;
    /**
     * 
     * @type {MasterProductVintageSku}
     * @memberof MasterProductVintageSkuListing
     */
    'masterProductVintageSku'?: MasterProductVintageSku;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'masterSkuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'sourceCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'externalListingId'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'pricePerCase'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'pricePerBottle'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'availableCases'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'stockOrigin'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'purchaseMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'newToBbx'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'labels'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'enPrimeur'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'bbxListingId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'hybrisBbxListingId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'lastUpdated'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MasterProductVintageSkuListing
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'baseEstimatedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'valuationConfidence'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'valuationCalculatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'investmentScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'investmentDiscount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'investmentAlert'?: MasterProductVintageSkuListingInvestmentAlertEnum;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'investmentReasoning'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'drinkingScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'drinkingDiscount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'drinkingAlert'?: MasterProductVintageSkuListingDrinkingAlertEnum;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'drinkingReasoning'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'currentHighestBid'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'bidToValueRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'suggestedBid'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'maxAllowedBid'?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'biddingAlert'?: MasterProductVintageSkuListingBiddingAlertEnum;
    /**
     * 
     * @type {string}
     * @memberof MasterProductVintageSkuListing
     */
    'biddingReasoning'?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     * @deprecated
     */
    'estimatedValueLegacy'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     * @deprecated
     */
    'discountPercentageLegacy'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     * @deprecated
     */
    'resalePotential'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     * @deprecated
     */
    'maturityMultiplierLegacy'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'priceToMarketPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'priceToWineSearcherPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'priceToLastTransactionPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'highestBidToMarketPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'priceToLowestListingPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'investmentMaturityMultiplier'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'drinkingMaturityMultiplier'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'estimatedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'discountPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'maturityMultiplier'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'investmentValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'drinkingValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof MasterProductVintageSkuListing
     */
    'bidTargetValue'?: number;
}

export const MasterProductVintageSkuListingInvestmentAlertEnum = {
    ExcellentBuy: 'EXCELLENT_BUY',
    GoodBuy: 'GOOD_BUY',
    FairValue: 'FAIR_VALUE',
    Overpriced: 'OVERPRICED',
    Avoid: 'AVOID'
} as const;

export type MasterProductVintageSkuListingInvestmentAlertEnum = typeof MasterProductVintageSkuListingInvestmentAlertEnum[keyof typeof MasterProductVintageSkuListingInvestmentAlertEnum];
export const MasterProductVintageSkuListingDrinkingAlertEnum = {
    ExcellentValue: 'EXCELLENT_VALUE',
    GoodValue: 'GOOD_VALUE',
    FairValue: 'FAIR_VALUE',
    PoorValue: 'POOR_VALUE',
    Avoid: 'AVOID'
} as const;

export type MasterProductVintageSkuListingDrinkingAlertEnum = typeof MasterProductVintageSkuListingDrinkingAlertEnum[keyof typeof MasterProductVintageSkuListingDrinkingAlertEnum];
export const MasterProductVintageSkuListingBiddingAlertEnum = {
    ExcellentOpportunity: 'EXCELLENT_OPPORTUNITY',
    GoodOpportunity: 'GOOD_OPPORTUNITY',
    FairOpportunity: 'FAIR_OPPORTUNITY',
    PoorOpportunity: 'POOR_OPPORTUNITY',
    NoOpportunity: 'NO_OPPORTUNITY'
} as const;

export type MasterProductVintageSkuListingBiddingAlertEnum = typeof MasterProductVintageSkuListingBiddingAlertEnum[keyof typeof MasterProductVintageSkuListingBiddingAlertEnum];

/**
 * 
 * @export
 * @interface MatchDetails
 */
export interface MatchDetails {
    /**
     * 
     * @type {boolean}
     * @memberof MatchDetails
     */
    'producerMatch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatchDetails
     */
    'countryMatch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatchDetails
     */
    'regionMatch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatchDetails
     */
    'subRegionMatch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatchDetails
     */
    'siteMatch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatchDetails
     */
    'wineNameMatch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatchDetails
     */
    'classificationMatch'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MatchDetails
     */
    'wineNameDetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchDetails
     */
    'subRegionDetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchDetails
     */
    'siteDetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchDetails
     */
    'producerDetail'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MatchDetails
     */
    'scoreBreakdown'?: { [key: string]: number; };
    /**
     * 
     * @type {Array<MatchQualityIndicator>}
     * @memberof MatchDetails
     */
    'qualityIndicators'?: Array<MatchQualityIndicator>;
}
/**
 * 
 * @export
 * @interface MatchQualityIndicator
 */
export interface MatchQualityIndicator {
    /**
     * 
     * @type {string}
     * @memberof MatchQualityIndicator
     */
    'type'?: MatchQualityIndicatorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MatchQualityIndicator
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchQualityIndicator
     */
    'impactOnScore'?: number;
}

export const MatchQualityIndicatorTypeEnum = {
    ExactMatch: 'EXACT_MATCH',
    PartialMatch: 'PARTIAL_MATCH',
    OverSpecific: 'OVER_SPECIFIC',
    MissingCritical: 'MISSING_CRITICAL'
} as const;

export type MatchQualityIndicatorTypeEnum = typeof MatchQualityIndicatorTypeEnum[keyof typeof MatchQualityIndicatorTypeEnum];

/**
 * 
 * @export
 * @interface PageImportSession
 */
export interface PageImportSession {
    /**
     * 
     * @type {number}
     * @memberof PageImportSession
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageImportSession
     */
    'totalPages'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageImportSession
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageImportSession
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageImportSession
     */
    'size'?: number;
    /**
     * 
     * @type {Array<ImportSession>}
     * @memberof PageImportSession
     */
    'content'?: Array<ImportSession>;
    /**
     * 
     * @type {number}
     * @memberof PageImportSession
     */
    'number'?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageImportSession
     */
    'sort'?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageImportSession
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageImportSession
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageImportSession
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageLwinReference
 */
export interface PageLwinReference {
    /**
     * 
     * @type {number}
     * @memberof PageLwinReference
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLwinReference
     */
    'totalPages'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageLwinReference
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLwinReference
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLwinReference
     */
    'size'?: number;
    /**
     * 
     * @type {Array<LwinReference>}
     * @memberof PageLwinReference
     */
    'content'?: Array<LwinReference>;
    /**
     * 
     * @type {number}
     * @memberof PageLwinReference
     */
    'number'?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLwinReference
     */
    'sort'?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLwinReference
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageLwinReference
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageLwinReference
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageMasterProduct
 */
export interface PageMasterProduct {
    /**
     * 
     * @type {number}
     * @memberof PageMasterProduct
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageMasterProduct
     */
    'totalPages'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageMasterProduct
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageMasterProduct
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageMasterProduct
     */
    'size'?: number;
    /**
     * 
     * @type {Array<MasterProduct>}
     * @memberof PageMasterProduct
     */
    'content'?: Array<MasterProduct>;
    /**
     * 
     * @type {number}
     * @memberof PageMasterProduct
     */
    'number'?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageMasterProduct
     */
    'sort'?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageMasterProduct
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageMasterProduct
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageMasterProduct
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface Pageable
 */
export interface Pageable {
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'size'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Pageable
     */
    'sort'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageableObject
     */
    'sort'?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
}
/**
 * 
 * @export
 * @interface SortObject
 */
export interface SortObject {
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    'direction'?: string;
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    'nullHandling'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'ascending'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    'property'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'ignoreCase'?: boolean;
}
/**
 * 
 * @export
 * @interface SourceInfo
 */
export interface SourceInfo {
    /**
     * 
     * @type {string}
     * @memberof SourceInfo
     */
    'sourceCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceInfo
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceInfo
     */
    'lastImported'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceInfo
     */
    'vintageCount'?: number;
}
/**
 * 
 * @export
 * @interface SourceProduct
 */
export interface SourceProduct {
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceProductId'?: string;
    /**
     * 
     * @type {MasterProduct}
     * @memberof SourceProduct
     */
    'masterProduct'?: MasterProduct;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceProducer'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceSubRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceColour'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'sourceCategory'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SourceProduct
     */
    'bbrOwnSelection'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SourceProduct
     */
    'sourceLwinReference'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProduct
     */
    'lastImported'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SourceProduct
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface SourceProductVintage
 */
export interface SourceProductVintage {
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintage
     */
    'sourceProductVintageId'?: string;
    /**
     * 
     * @type {SourceProduct}
     * @memberof SourceProductVintage
     */
    'sourceProduct'?: SourceProduct;
    /**
     * 
     * @type {MasterProductVintage}
     * @memberof SourceProductVintage
     */
    'masterProductVintage'?: MasterProductVintage;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintage
     */
    'externalVintageId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintage
     */
    'vintage'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintage
     */
    'sourceMaturity'?: SourceProductVintageSourceMaturityEnum;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintage
     */
    'sourceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintage
     */
    'sourceExpertReview'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintage
     */
    'sourceAlcoholPercentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintage
     */
    'sourceGrapeVarieties'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintage
     */
    'sourceSweetness'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintage
     */
    'drinkingFromYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintage
     */
    'drinkingToYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintage
     */
    'lastUpdated'?: string;
    /**
     * 
     * @type {Set<SourceProductVintageSku>}
     * @memberof SourceProductVintage
     */
    'productVintageSkus'?: Set<SourceProductVintageSku>;
    /**
     * 
     * @type {Set<SourceProductVintageCriticReview>}
     * @memberof SourceProductVintage
     */
    'criticReviews'?: Set<SourceProductVintageCriticReview>;
}

export const SourceProductVintageSourceMaturityEnum = {
    Unknown: 'UNKNOWN',
    NotReady: 'NOT_READY',
    ReadyYoung: 'READY_YOUNG',
    ReadyAtBest: 'READY_AT_BEST',
    ReadyMature: 'READY_MATURE'
} as const;

export type SourceProductVintageSourceMaturityEnum = typeof SourceProductVintageSourceMaturityEnum[keyof typeof SourceProductVintageSourceMaturityEnum];

/**
 * 
 * @export
 * @interface SourceProductVintageCriticReview
 */
export interface SourceProductVintageCriticReview {
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageCriticReview
     */
    'reviewId'?: string;
    /**
     * 
     * @type {SourceProductVintage}
     * @memberof SourceProductVintageCriticReview
     */
    'sourceProductVintage'?: SourceProductVintage;
    /**
     * 
     * @type {WineCritic}
     * @memberof SourceProductVintageCriticReview
     */
    'wineCritic'?: WineCritic;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageCriticReview
     */
    'score'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageCriticReview
     */
    'reviewDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageCriticReview
     */
    'reviewText'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageCriticReview
     */
    'drinkingFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageCriticReview
     */
    'drinkingTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageCriticReview
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageCriticReview
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface SourceProductVintageSku
 */
export interface SourceProductVintageSku {
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageSku
     */
    'sourceSkuId'?: string;
    /**
     * 
     * @type {SourceProductVintage}
     * @memberof SourceProductVintageSku
     */
    'sourceProductVintage'?: SourceProductVintage;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageSku
     */
    'externalSkuId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintageSku
     */
    'bottleSizeMl'?: number;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintageSku
     */
    'caseSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintageSku
     */
    'adjustedMarketPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageSku
     */
    'adjustedMarketPriceUpdateDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintageSku
     */
    'lastTransaction'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageSku
     */
    'lastTransactionUpdateDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintageSku
     */
    'highestBid'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageSku
     */
    'highestBidUpdateDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintageSku
     */
    'leastListingPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageSku
     */
    'leastListingPriceUpdateDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceProductVintageSku
     */
    'wineSearcherPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageSku
     */
    'wineSearcherPriceUpdateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceProductVintageSku
     */
    'lastUpdated'?: string;
}
/**
 * 
 * @export
 * @interface WineAlertDTO
 */
export interface WineAlertDTO {
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'ruleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'listingId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'status'?: WineAlertDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'triggerType'?: WineAlertDTOTriggerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'snapshotPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'snapshotMarketValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'snapshotWineSearcherLow'?: number;
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'snapshotDiscountVsMarket'?: number;
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'snapshotCriticScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'previousPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'triggeredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'reviewedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'reviewNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'wineName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'producer'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineAlertDTO
     */
    'region'?: string;
    /**
     * 
     * @type {number}
     * @memberof WineAlertDTO
     */
    'vintage'?: number;
}

export const WineAlertDTOStatusEnum = {
    New: 'NEW',
    Reviewed: 'REVIEWED',
    Dismissed: 'DISMISSED',
    Interesting: 'INTERESTING',
    Purchased: 'PURCHASED'
} as const;

export type WineAlertDTOStatusEnum = typeof WineAlertDTOStatusEnum[keyof typeof WineAlertDTOStatusEnum];
export const WineAlertDTOTriggerTypeEnum = {
    NewListing: 'NEW_LISTING',
    PriceDrop: 'PRICE_DROP',
    Revaluation: 'REVALUATION',
    ManualScan: 'MANUAL_SCAN'
} as const;

export type WineAlertDTOTriggerTypeEnum = typeof WineAlertDTOTriggerTypeEnum[keyof typeof WineAlertDTOTriggerTypeEnum];

/**
 * 
 * @export
 * @interface WineCritic
 */
export interface WineCritic {
    /**
     * 
     * @type {number}
     * @memberof WineCritic
     */
    'criticId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WineCritic
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineCritic
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineCritic
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof WineCritic
     */
    'updatedAt'?: string;
}

/**
 * AlertControllerApi - axios parameter creator
 * @export
 */
export const AlertControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BulkAlertStatusUpdateRequest} bulkAlertStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateStatus: async (bulkAlertStatusUpdateRequest: BulkAlertStatusUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkAlertStatusUpdateRequest' is not null or undefined
            assertParamExists('bulkUpdateStatus', 'bulkAlertStatusUpdateRequest', bulkAlertStatusUpdateRequest)
            const localVarPath = `/api/alerts/bulk-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAlertStatusUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AlertRuleRequest} alertRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRule: async (alertRuleRequest: AlertRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alertRuleRequest' is not null or undefined
            assertParamExists('createRule', 'alertRuleRequest', alertRuleRequest)
            const localVarPath = `/api/alerts/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAlert', 'id', id)
            const localVarPath = `/api/alerts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRule: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRule', 'id', id)
            const localVarPath = `/api/alerts/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlert: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAlert', 'id', id)
            const localVarPath = `/api/alerts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertCounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alerts/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAlertsStatusEnum} [status] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts: async (status?: GetAlertsStatusEnum, page?: number, size?: number, sortBy?: string, sortDir?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertsForListing: async (listingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('getAlertsForListing', 'listingId', listingId)
            const localVarPath = `/api/alerts/listing/{listingId}`
                .replace(`{${"listingId"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertsForRule: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAlertsForRule', 'id', id)
            const localVarPath = `/api/alerts/rules/{id}/alerts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRules: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alerts/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewAlerts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alerts/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRule', 'id', id)
            const localVarPath = `/api/alerts/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleStats: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRuleStats', 'id', id)
            const localVarPath = `/api/alerts/rules/{id}/stats`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testRule: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('testRule', 'id', id)
            const localVarPath = `/api/alerts/rules/{id}/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AlertStatusUpdateRequest} alertStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertStatus: async (id: number, alertStatusUpdateRequest: AlertStatusUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAlertStatus', 'id', id)
            // verify required parameter 'alertStatusUpdateRequest' is not null or undefined
            assertParamExists('updateAlertStatus', 'alertStatusUpdateRequest', alertStatusUpdateRequest)
            const localVarPath = `/api/alerts/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertStatusUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {AlertRuleRequest} alertRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRule: async (id: number, alertRuleRequest: AlertRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRule', 'id', id)
            // verify required parameter 'alertRuleRequest' is not null or undefined
            assertParamExists('updateRule', 'alertRuleRequest', alertRuleRequest)
            const localVarPath = `/api/alerts/rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlertControllerApi - functional programming interface
 * @export
 */
export const AlertControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlertControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BulkAlertStatusUpdateRequest} bulkAlertStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateStatus(bulkAlertStatusUpdateRequest: BulkAlertStatusUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateStatus(bulkAlertStatusUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.bulkUpdateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AlertRuleRequest} alertRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRule(alertRuleRequest: AlertRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertRuleDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRule(alertRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.createRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlert(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlert(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.deleteAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRule(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.deleteRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlert(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WineAlertDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlert(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getAlert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlertCounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlertCounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getAlertCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAlertsStatusEnum} [status] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlerts(status?: GetAlertsStatusEnum, page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlerts(status, page, size, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlertsForListing(listingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WineAlertDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlertsForListing(listingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getAlertsForListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlertsForRule(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WineAlertDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlertsForRule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getAlertsForRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRules(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlertRuleDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRules(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getAllRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewAlerts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WineAlertDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewAlerts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getNewAlerts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRule(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertRuleDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRuleStats(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRuleStats(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.getRuleStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testRule(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testRule(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.testRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {AlertStatusUpdateRequest} alertStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAlertStatus(id: number, alertStatusUpdateRequest: AlertStatusUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WineAlertDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAlertStatus(id, alertStatusUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.updateAlertStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {AlertRuleRequest} alertRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRule(id: number, alertRuleRequest: AlertRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertRuleDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRule(id, alertRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlertControllerApi.updateRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlertControllerApi - factory interface
 * @export
 */
export const AlertControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlertControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {BulkAlertStatusUpdateRequest} bulkAlertStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateStatus(bulkAlertStatusUpdateRequest: BulkAlertStatusUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.bulkUpdateStatus(bulkAlertStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AlertRuleRequest} alertRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRule(alertRuleRequest: AlertRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<AlertRuleDTO> {
            return localVarFp.createRule(alertRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAlert(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRule(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlert(id: number, options?: RawAxiosRequestConfig): AxiosPromise<WineAlertDTO> {
            return localVarFp.getAlert(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertCounts(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getAlertCounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetAlertsStatusEnum} [status] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(status?: GetAlertsStatusEnum, page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getAlerts(status, page, size, sortBy, sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} listingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertsForListing(listingId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<WineAlertDTO>> {
            return localVarFp.getAlertsForListing(listingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertsForRule(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<WineAlertDTO>> {
            return localVarFp.getAlertsForRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRules(options?: RawAxiosRequestConfig): AxiosPromise<Array<AlertRuleDTO>> {
            return localVarFp.getAllRules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewAlerts(options?: RawAxiosRequestConfig): AxiosPromise<Array<WineAlertDTO>> {
            return localVarFp.getNewAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRule(id: number, options?: RawAxiosRequestConfig): AxiosPromise<AlertRuleDTO> {
            return localVarFp.getRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleStats(id: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getRuleStats(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testRule(id: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.testRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AlertStatusUpdateRequest} alertStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertStatus(id: number, alertStatusUpdateRequest: AlertStatusUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<WineAlertDTO> {
            return localVarFp.updateAlertStatus(id, alertStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {AlertRuleRequest} alertRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRule(id: number, alertRuleRequest: AlertRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<AlertRuleDTO> {
            return localVarFp.updateRule(id, alertRuleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlertControllerApi - object-oriented interface
 * @export
 * @class AlertControllerApi
 * @extends {BaseAPI}
 */
export class AlertControllerApi extends BaseAPI {
    /**
     * 
     * @param {BulkAlertStatusUpdateRequest} bulkAlertStatusUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public bulkUpdateStatus(bulkAlertStatusUpdateRequest: BulkAlertStatusUpdateRequest, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).bulkUpdateStatus(bulkAlertStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AlertRuleRequest} alertRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public createRule(alertRuleRequest: AlertRuleRequest, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).createRule(alertRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public deleteAlert(id: number, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).deleteAlert(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public deleteRule(id: number, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).deleteRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getAlert(id: number, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getAlert(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getAlertCounts(options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getAlertCounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetAlertsStatusEnum} [status] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDir] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getAlerts(status?: GetAlertsStatusEnum, page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getAlerts(status, page, size, sortBy, sortDir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} listingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getAlertsForListing(listingId: string, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getAlertsForListing(listingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getAlertsForRule(id: number, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getAlertsForRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getAllRules(options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getAllRules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getNewAlerts(options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getNewAlerts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getRule(id: number, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getRuleStats(id: number, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).getRuleStats(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public testRule(id: number, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).testRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {AlertStatusUpdateRequest} alertStatusUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public updateAlertStatus(id: number, alertStatusUpdateRequest: AlertStatusUpdateRequest, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).updateAlertStatus(id, alertStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {AlertRuleRequest} alertRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public updateRule(id: number, alertRuleRequest: AlertRuleRequest, options?: RawAxiosRequestConfig) {
        return AlertControllerApiFp(this.configuration).updateRule(id, alertRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAlertsStatusEnum = {
    New: 'NEW',
    Reviewed: 'REVIEWED',
    Dismissed: 'DISMISSED',
    Interesting: 'INTERESTING',
    Purchased: 'PURCHASED'
} as const;
export type GetAlertsStatusEnum = typeof GetAlertsStatusEnum[keyof typeof GetAlertsStatusEnum];


/**
 * DataSourceControllerApi - axios parameter creator
 * @export
 */
export const DataSourceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DataSourceCreateRequest} dataSourceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataSource: async (dataSourceCreateRequest: DataSourceCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSourceCreateRequest' is not null or undefined
            assertParamExists('createDataSource', 'dataSourceCreateRequest', dataSourceCreateRequest)
            const localVarPath = `/api/data-sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataSourceCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSource: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('deleteDataSource', 'code', code)
            const localVarPath = `/api/data-sources/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSession: async (sessionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('deleteSession', 'sessionId', sessionId)
            const localVarPath = `/api/data-sources/imports/sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDataSources: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/data-sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllImportSessions: async (page?: number, size?: number, sortBy?: string, sortDir?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/data-sources/imports/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRunningImports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/data-sources/imports/running`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourceByCode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getDataSourceByCode', 'code', code)
            const localVarPath = `/api/data-sources/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledDataSources: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/data-sources/enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportSession: async (sessionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getImportSession', 'sessionId', sessionId)
            const localVarPath = `/api/data-sources/imports/sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportSessions: async (code: string, page?: number, size?: number, sortBy?: string, sortDir?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getImportSessions', 'code', code)
            const localVarPath = `/api/data-sources/{code}/imports`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestImportSession: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getLatestImportSession', 'code', code)
            const localVarPath = `/api/data-sources/{code}/imports/latest`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunningImportSession: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getRunningImportSession', 'code', code)
            const localVarPath = `/api/data-sources/{code}/imports/running`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetStatistics: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('resetStatistics', 'code', code)
            const localVarPath = `/api/data-sources/{code}/reset-stats`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {ImportConfigRequest} [importConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImport: async (code: string, importConfigRequest?: ImportConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('startImport', 'code', code)
            const localVarPath = `/api/data-sources/{code}/imports/start`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopImportSession: async (code: string, sessionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('stopImportSession', 'code', code)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('stopImportSession', 'sessionId', sessionId)
            const localVarPath = `/api/data-sources/{code}/imports/{sessionId}/stop`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDataSource: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('toggleDataSource', 'code', code)
            const localVarPath = `/api/data-sources/{code}/toggle`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {DataSourceUpdateRequest} dataSourceUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDataSource: async (code: string, dataSourceUpdateRequest: DataSourceUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('updateDataSource', 'code', code)
            // verify required parameter 'dataSourceUpdateRequest' is not null or undefined
            assertParamExists('updateDataSource', 'dataSourceUpdateRequest', dataSourceUpdateRequest)
            const localVarPath = `/api/data-sources/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataSourceUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataSourceControllerApi - functional programming interface
 * @export
 */
export const DataSourceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataSourceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DataSourceCreateRequest} dataSourceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDataSource(dataSourceCreateRequest: DataSourceCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDataSource(dataSourceCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.createDataSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDataSource(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDataSource(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.deleteDataSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSession(sessionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSession(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.deleteSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDataSources(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDataSources(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getAllDataSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllImportSessions(page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageImportSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllImportSessions(page, size, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getAllImportSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRunningImports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImportSession>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRunningImports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getAllRunningImports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataSourceByCode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataSource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataSourceByCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getDataSourceByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnabledDataSources(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnabledDataSources(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getEnabledDataSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportSession(sessionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportSession(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getImportSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportSessions(code: string, page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageImportSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportSessions(code, page, size, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getImportSessions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestImportSession(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestImportSession(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getLatestImportSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRunningImportSession(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRunningImportSession(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.getRunningImportSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetStatistics(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetStatistics(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.resetStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {ImportConfigRequest} [importConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startImport(code: string, importConfigRequest?: ImportConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startImport(code, importConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.startImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopImportSession(code: string, sessionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopImportSession(code, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.stopImportSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleDataSource(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleDataSource(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.toggleDataSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {DataSourceUpdateRequest} dataSourceUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDataSource(code: string, dataSourceUpdateRequest: DataSourceUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDataSource(code, dataSourceUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataSourceControllerApi.updateDataSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataSourceControllerApi - factory interface
 * @export
 */
export const DataSourceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataSourceControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DataSourceCreateRequest} dataSourceCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataSource(dataSourceCreateRequest: DataSourceCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.createDataSource(dataSourceCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSource(code: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteDataSource(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSession(sessionId: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.deleteSession(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDataSources(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSource>> {
            return localVarFp.getAllDataSources(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllImportSessions(page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageImportSession> {
            return localVarFp.getAllImportSessions(page, size, sortBy, sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRunningImports(options?: RawAxiosRequestConfig): AxiosPromise<Array<ImportSession>> {
            return localVarFp.getAllRunningImports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSourceByCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<DataSource> {
            return localVarFp.getDataSourceByCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledDataSources(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSource>> {
            return localVarFp.getEnabledDataSources(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportSession(sessionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ImportSession> {
            return localVarFp.getImportSession(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportSessions(code: string, page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageImportSession> {
            return localVarFp.getImportSessions(code, page, size, sortBy, sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestImportSession(code: string, options?: RawAxiosRequestConfig): AxiosPromise<ImportSession> {
            return localVarFp.getLatestImportSession(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunningImportSession(code: string, options?: RawAxiosRequestConfig): AxiosPromise<ImportSession> {
            return localVarFp.getRunningImportSession(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetStatistics(code: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.resetStatistics(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {ImportConfigRequest} [importConfigRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImport(code: string, importConfigRequest?: ImportConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.startImport(code, importConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopImportSession(code: string, sessionId: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.stopImportSession(code, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDataSource(code: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.toggleDataSource(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {DataSourceUpdateRequest} dataSourceUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDataSource(code: string, dataSourceUpdateRequest: DataSourceUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateDataSource(code, dataSourceUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataSourceControllerApi - object-oriented interface
 * @export
 * @class DataSourceControllerApi
 * @extends {BaseAPI}
 */
export class DataSourceControllerApi extends BaseAPI {
    /**
     * 
     * @param {DataSourceCreateRequest} dataSourceCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public createDataSource(dataSourceCreateRequest: DataSourceCreateRequest, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).createDataSource(dataSourceCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public deleteDataSource(code: string, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).deleteDataSource(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public deleteSession(sessionId: number, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).deleteSession(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getAllDataSources(options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getAllDataSources(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDir] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getAllImportSessions(page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getAllImportSessions(page, size, sortBy, sortDir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getAllRunningImports(options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getAllRunningImports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getDataSourceByCode(code: string, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getDataSourceByCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getEnabledDataSources(options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getEnabledDataSources(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getImportSession(sessionId: number, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getImportSession(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [sortDir] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getImportSessions(code: string, page?: number, size?: number, sortBy?: string, sortDir?: string, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getImportSessions(code, page, size, sortBy, sortDir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getLatestImportSession(code: string, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getLatestImportSession(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public getRunningImportSession(code: string, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).getRunningImportSession(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public resetStatistics(code: string, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).resetStatistics(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {ImportConfigRequest} [importConfigRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public startImport(code: string, importConfigRequest?: ImportConfigRequest, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).startImport(code, importConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {number} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public stopImportSession(code: string, sessionId: number, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).stopImportSession(code, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public toggleDataSource(code: string, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).toggleDataSource(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {DataSourceUpdateRequest} dataSourceUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataSourceControllerApi
     */
    public updateDataSource(code: string, dataSourceUpdateRequest: DataSourceUpdateRequest, options?: RawAxiosRequestConfig) {
        return DataSourceControllerApiFp(this.configuration).updateDataSource(code, dataSourceUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LwinReferenceControllerApi - axios parameter creator
 * @export
 */
export const LwinReferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LwinReference} lwinReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLwinReference: async (lwinReference: LwinReference, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lwinReference' is not null or undefined
            assertParamExists('createLwinReference', 'lwinReference', lwinReference)
            const localVarPath = `/api/lwin-references`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lwinReference, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLwinReference: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLwinReference', 'id', id)
            const localVarPath = `/api/lwin-references/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {number} [lwin] 
         * @param {string} [status] 
         * @param {string} [displayName] 
         * @param {string} [producerTitle] 
         * @param {string} [producerName] 
         * @param {string} [wine] 
         * @param {string} [country] 
         * @param {string} [region] 
         * @param {string} [subRegion] 
         * @param {string} [site] 
         * @param {string} [parcel] 
         * @param {string} [colour] 
         * @param {string} [type] 
         * @param {string} [subType] 
         * @param {string} [designation] 
         * @param {string} [classification] 
         * @param {string} [vintageConfig] 
         * @param {number} [firstVintageMin] 
         * @param {number} [firstVintageMax] 
         * @param {number} [finalVintageMin] 
         * @param {number} [finalVintageMax] 
         * @param {string} [dateAddedAfter] 
         * @param {string} [dateAddedBefore] 
         * @param {string} [dateUpdatedAfter] 
         * @param {string} [dateUpdatedBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLwinReferences: async (pageable: Pageable, lwin?: number, status?: string, displayName?: string, producerTitle?: string, producerName?: string, wine?: string, country?: string, region?: string, subRegion?: string, site?: string, parcel?: string, colour?: string, type?: string, subType?: string, designation?: string, classification?: string, vintageConfig?: string, firstVintageMin?: number, firstVintageMax?: number, finalVintageMin?: number, finalVintageMax?: number, dateAddedAfter?: string, dateAddedBefore?: string, dateUpdatedAfter?: string, dateUpdatedBefore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getAllLwinReferences', 'pageable', pageable)
            const localVarPath = `/api/lwin-references`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lwin !== undefined) {
                localVarQueryParameter['lwin'] = lwin;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (displayName !== undefined) {
                localVarQueryParameter['displayName'] = displayName;
            }

            if (producerTitle !== undefined) {
                localVarQueryParameter['producerTitle'] = producerTitle;
            }

            if (producerName !== undefined) {
                localVarQueryParameter['producerName'] = producerName;
            }

            if (wine !== undefined) {
                localVarQueryParameter['wine'] = wine;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (subRegion !== undefined) {
                localVarQueryParameter['subRegion'] = subRegion;
            }

            if (site !== undefined) {
                localVarQueryParameter['site'] = site;
            }

            if (parcel !== undefined) {
                localVarQueryParameter['parcel'] = parcel;
            }

            if (colour !== undefined) {
                localVarQueryParameter['colour'] = colour;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (subType !== undefined) {
                localVarQueryParameter['subType'] = subType;
            }

            if (designation !== undefined) {
                localVarQueryParameter['designation'] = designation;
            }

            if (classification !== undefined) {
                localVarQueryParameter['classification'] = classification;
            }

            if (vintageConfig !== undefined) {
                localVarQueryParameter['vintageConfig'] = vintageConfig;
            }

            if (firstVintageMin !== undefined) {
                localVarQueryParameter['firstVintageMin'] = firstVintageMin;
            }

            if (firstVintageMax !== undefined) {
                localVarQueryParameter['firstVintageMax'] = firstVintageMax;
            }

            if (finalVintageMin !== undefined) {
                localVarQueryParameter['finalVintageMin'] = finalVintageMin;
            }

            if (finalVintageMax !== undefined) {
                localVarQueryParameter['finalVintageMax'] = finalVintageMax;
            }

            if (dateAddedAfter !== undefined) {
                localVarQueryParameter['dateAddedAfter'] = (dateAddedAfter as any instanceof Date) ?
                    (dateAddedAfter as any).toISOString().substring(0,10) :
                    dateAddedAfter;
            }

            if (dateAddedBefore !== undefined) {
                localVarQueryParameter['dateAddedBefore'] = (dateAddedBefore as any instanceof Date) ?
                    (dateAddedBefore as any).toISOString().substring(0,10) :
                    dateAddedBefore;
            }

            if (dateUpdatedAfter !== undefined) {
                localVarQueryParameter['dateUpdatedAfter'] = (dateUpdatedAfter as any instanceof Date) ?
                    (dateUpdatedAfter as any).toISOString().substring(0,10) :
                    dateUpdatedAfter;
            }

            if (dateUpdatedBefore !== undefined) {
                localVarQueryParameter['dateUpdatedBefore'] = (dateUpdatedBefore as any instanceof Date) ?
                    (dateUpdatedBefore as any).toISOString().substring(0,10) :
                    dateUpdatedBefore;
            }

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLwinReferenceById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLwinReferenceById', 'id', id)
            const localVarPath = `/api/lwin-references/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLwinReferenceFilters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lwin-references/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {LwinReference} lwinReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLwinReference: async (id: number, lwinReference: LwinReference, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLwinReference', 'id', id)
            // verify required parameter 'lwinReference' is not null or undefined
            assertParamExists('updateLwinReference', 'lwinReference', lwinReference)
            const localVarPath = `/api/lwin-references/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lwinReference, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LwinReferenceControllerApi - functional programming interface
 * @export
 */
export const LwinReferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LwinReferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LwinReference} lwinReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLwinReference(lwinReference: LwinReference, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LwinReference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLwinReference(lwinReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LwinReferenceControllerApi.createLwinReference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLwinReference(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLwinReference(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LwinReferenceControllerApi.deleteLwinReference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {number} [lwin] 
         * @param {string} [status] 
         * @param {string} [displayName] 
         * @param {string} [producerTitle] 
         * @param {string} [producerName] 
         * @param {string} [wine] 
         * @param {string} [country] 
         * @param {string} [region] 
         * @param {string} [subRegion] 
         * @param {string} [site] 
         * @param {string} [parcel] 
         * @param {string} [colour] 
         * @param {string} [type] 
         * @param {string} [subType] 
         * @param {string} [designation] 
         * @param {string} [classification] 
         * @param {string} [vintageConfig] 
         * @param {number} [firstVintageMin] 
         * @param {number} [firstVintageMax] 
         * @param {number} [finalVintageMin] 
         * @param {number} [finalVintageMax] 
         * @param {string} [dateAddedAfter] 
         * @param {string} [dateAddedBefore] 
         * @param {string} [dateUpdatedAfter] 
         * @param {string} [dateUpdatedBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLwinReferences(pageable: Pageable, lwin?: number, status?: string, displayName?: string, producerTitle?: string, producerName?: string, wine?: string, country?: string, region?: string, subRegion?: string, site?: string, parcel?: string, colour?: string, type?: string, subType?: string, designation?: string, classification?: string, vintageConfig?: string, firstVintageMin?: number, firstVintageMax?: number, finalVintageMin?: number, finalVintageMax?: number, dateAddedAfter?: string, dateAddedBefore?: string, dateUpdatedAfter?: string, dateUpdatedBefore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLwinReference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLwinReferences(pageable, lwin, status, displayName, producerTitle, producerName, wine, country, region, subRegion, site, parcel, colour, type, subType, designation, classification, vintageConfig, firstVintageMin, firstVintageMax, finalVintageMin, finalVintageMax, dateAddedAfter, dateAddedBefore, dateUpdatedAfter, dateUpdatedBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LwinReferenceControllerApi.getAllLwinReferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLwinReferenceById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LwinReference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLwinReferenceById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LwinReferenceControllerApi.getLwinReferenceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLwinReferenceFilters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LwinReferenceFilterValues>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLwinReferenceFilters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LwinReferenceControllerApi.getLwinReferenceFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {LwinReference} lwinReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLwinReference(id: number, lwinReference: LwinReference, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LwinReference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLwinReference(id, lwinReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LwinReferenceControllerApi.updateLwinReference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LwinReferenceControllerApi - factory interface
 * @export
 */
export const LwinReferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LwinReferenceControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {LwinReference} lwinReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLwinReference(lwinReference: LwinReference, options?: RawAxiosRequestConfig): AxiosPromise<LwinReference> {
            return localVarFp.createLwinReference(lwinReference, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLwinReference(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLwinReference(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {number} [lwin] 
         * @param {string} [status] 
         * @param {string} [displayName] 
         * @param {string} [producerTitle] 
         * @param {string} [producerName] 
         * @param {string} [wine] 
         * @param {string} [country] 
         * @param {string} [region] 
         * @param {string} [subRegion] 
         * @param {string} [site] 
         * @param {string} [parcel] 
         * @param {string} [colour] 
         * @param {string} [type] 
         * @param {string} [subType] 
         * @param {string} [designation] 
         * @param {string} [classification] 
         * @param {string} [vintageConfig] 
         * @param {number} [firstVintageMin] 
         * @param {number} [firstVintageMax] 
         * @param {number} [finalVintageMin] 
         * @param {number} [finalVintageMax] 
         * @param {string} [dateAddedAfter] 
         * @param {string} [dateAddedBefore] 
         * @param {string} [dateUpdatedAfter] 
         * @param {string} [dateUpdatedBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLwinReferences(pageable: Pageable, lwin?: number, status?: string, displayName?: string, producerTitle?: string, producerName?: string, wine?: string, country?: string, region?: string, subRegion?: string, site?: string, parcel?: string, colour?: string, type?: string, subType?: string, designation?: string, classification?: string, vintageConfig?: string, firstVintageMin?: number, firstVintageMax?: number, finalVintageMin?: number, finalVintageMax?: number, dateAddedAfter?: string, dateAddedBefore?: string, dateUpdatedAfter?: string, dateUpdatedBefore?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLwinReference> {
            return localVarFp.getAllLwinReferences(pageable, lwin, status, displayName, producerTitle, producerName, wine, country, region, subRegion, site, parcel, colour, type, subType, designation, classification, vintageConfig, firstVintageMin, firstVintageMax, finalVintageMin, finalVintageMax, dateAddedAfter, dateAddedBefore, dateUpdatedAfter, dateUpdatedBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLwinReferenceById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<LwinReference> {
            return localVarFp.getLwinReferenceById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLwinReferenceFilters(options?: RawAxiosRequestConfig): AxiosPromise<LwinReferenceFilterValues> {
            return localVarFp.getLwinReferenceFilters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {LwinReference} lwinReference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLwinReference(id: number, lwinReference: LwinReference, options?: RawAxiosRequestConfig): AxiosPromise<LwinReference> {
            return localVarFp.updateLwinReference(id, lwinReference, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LwinReferenceControllerApi - object-oriented interface
 * @export
 * @class LwinReferenceControllerApi
 * @extends {BaseAPI}
 */
export class LwinReferenceControllerApi extends BaseAPI {
    /**
     * 
     * @param {LwinReference} lwinReference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LwinReferenceControllerApi
     */
    public createLwinReference(lwinReference: LwinReference, options?: RawAxiosRequestConfig) {
        return LwinReferenceControllerApiFp(this.configuration).createLwinReference(lwinReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LwinReferenceControllerApi
     */
    public deleteLwinReference(id: number, options?: RawAxiosRequestConfig) {
        return LwinReferenceControllerApiFp(this.configuration).deleteLwinReference(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Pageable} pageable 
     * @param {number} [lwin] 
     * @param {string} [status] 
     * @param {string} [displayName] 
     * @param {string} [producerTitle] 
     * @param {string} [producerName] 
     * @param {string} [wine] 
     * @param {string} [country] 
     * @param {string} [region] 
     * @param {string} [subRegion] 
     * @param {string} [site] 
     * @param {string} [parcel] 
     * @param {string} [colour] 
     * @param {string} [type] 
     * @param {string} [subType] 
     * @param {string} [designation] 
     * @param {string} [classification] 
     * @param {string} [vintageConfig] 
     * @param {number} [firstVintageMin] 
     * @param {number} [firstVintageMax] 
     * @param {number} [finalVintageMin] 
     * @param {number} [finalVintageMax] 
     * @param {string} [dateAddedAfter] 
     * @param {string} [dateAddedBefore] 
     * @param {string} [dateUpdatedAfter] 
     * @param {string} [dateUpdatedBefore] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LwinReferenceControllerApi
     */
    public getAllLwinReferences(pageable: Pageable, lwin?: number, status?: string, displayName?: string, producerTitle?: string, producerName?: string, wine?: string, country?: string, region?: string, subRegion?: string, site?: string, parcel?: string, colour?: string, type?: string, subType?: string, designation?: string, classification?: string, vintageConfig?: string, firstVintageMin?: number, firstVintageMax?: number, finalVintageMin?: number, finalVintageMax?: number, dateAddedAfter?: string, dateAddedBefore?: string, dateUpdatedAfter?: string, dateUpdatedBefore?: string, options?: RawAxiosRequestConfig) {
        return LwinReferenceControllerApiFp(this.configuration).getAllLwinReferences(pageable, lwin, status, displayName, producerTitle, producerName, wine, country, region, subRegion, site, parcel, colour, type, subType, designation, classification, vintageConfig, firstVintageMin, firstVintageMax, finalVintageMin, finalVintageMax, dateAddedAfter, dateAddedBefore, dateUpdatedAfter, dateUpdatedBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LwinReferenceControllerApi
     */
    public getLwinReferenceById(id: number, options?: RawAxiosRequestConfig) {
        return LwinReferenceControllerApiFp(this.configuration).getLwinReferenceById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LwinReferenceControllerApi
     */
    public getLwinReferenceFilters(options?: RawAxiosRequestConfig) {
        return LwinReferenceControllerApiFp(this.configuration).getLwinReferenceFilters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {LwinReference} lwinReference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LwinReferenceControllerApi
     */
    public updateLwinReference(id: number, lwinReference: LwinReference, options?: RawAxiosRequestConfig) {
        return LwinReferenceControllerApiFp(this.configuration).updateLwinReference(id, lwinReference, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MasterProductControllerApi - axios parameter creator
 * @export
 */
export const MasterProductControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Pageable} pageable 
         * @param {string} [name] 
         * @param {string} [producer] 
         * @param {string} [country] 
         * @param {string} [region] 
         * @param {string} [subRegion] 
         * @param {string} [colour] 
         * @param {string} [category] 
         * @param {boolean} [hasLwin] 
         * @param {Set<string>} [sourceCodes] 
         * @param {string} [modifiedAfter] 
         * @param {string} [modifiedBefore] 
         * @param {number} [priceToMarketPercentageMin] 
         * @param {number} [priceToMarketPercentageMax] 
         * @param {number} [priceToWineSearcherPercentageMin] 
         * @param {number} [priceToWineSearcherPercentageMax] 
         * @param {number} [priceToLastTransactionPercentageMin] 
         * @param {number} [priceToLastTransactionPercentageMax] 
         * @param {number} [highestBidToMarketPercentageMin] 
         * @param {number} [highestBidToMarketPercentageMax] 
         * @param {string} [maturity] 
         * @param {number} [drinkingFromYear] 
         * @param {number} [drinkingToYear] 
         * @param {boolean} [hasCriticReviews] 
         * @param {number} [criticScoreMin] 
         * @param {number} [criticScoreMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMasterProducts: async (pageable: Pageable, name?: string, producer?: string, country?: string, region?: string, subRegion?: string, colour?: string, category?: string, hasLwin?: boolean, sourceCodes?: Set<string>, modifiedAfter?: string, modifiedBefore?: string, priceToMarketPercentageMin?: number, priceToMarketPercentageMax?: number, priceToWineSearcherPercentageMin?: number, priceToWineSearcherPercentageMax?: number, priceToLastTransactionPercentageMin?: number, priceToLastTransactionPercentageMax?: number, highestBidToMarketPercentageMin?: number, highestBidToMarketPercentageMax?: number, maturity?: string, drinkingFromYear?: number, drinkingToYear?: number, hasCriticReviews?: boolean, criticScoreMin?: number, criticScoreMax?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getAllMasterProducts', 'pageable', pageable)
            const localVarPath = `/api/master-products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (producer !== undefined) {
                localVarQueryParameter['producer'] = producer;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (subRegion !== undefined) {
                localVarQueryParameter['subRegion'] = subRegion;
            }

            if (colour !== undefined) {
                localVarQueryParameter['colour'] = colour;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (hasLwin !== undefined) {
                localVarQueryParameter['hasLwin'] = hasLwin;
            }

            if (sourceCodes) {
                localVarQueryParameter['sourceCodes'] = Array.from(sourceCodes);
            }

            if (modifiedAfter !== undefined) {
                localVarQueryParameter['modifiedAfter'] = (modifiedAfter as any instanceof Date) ?
                    (modifiedAfter as any).toISOString().substring(0,10) :
                    modifiedAfter;
            }

            if (modifiedBefore !== undefined) {
                localVarQueryParameter['modifiedBefore'] = (modifiedBefore as any instanceof Date) ?
                    (modifiedBefore as any).toISOString().substring(0,10) :
                    modifiedBefore;
            }

            if (priceToMarketPercentageMin !== undefined) {
                localVarQueryParameter['priceToMarketPercentageMin'] = priceToMarketPercentageMin;
            }

            if (priceToMarketPercentageMax !== undefined) {
                localVarQueryParameter['priceToMarketPercentageMax'] = priceToMarketPercentageMax;
            }

            if (priceToWineSearcherPercentageMin !== undefined) {
                localVarQueryParameter['priceToWineSearcherPercentageMin'] = priceToWineSearcherPercentageMin;
            }

            if (priceToWineSearcherPercentageMax !== undefined) {
                localVarQueryParameter['priceToWineSearcherPercentageMax'] = priceToWineSearcherPercentageMax;
            }

            if (priceToLastTransactionPercentageMin !== undefined) {
                localVarQueryParameter['priceToLastTransactionPercentageMin'] = priceToLastTransactionPercentageMin;
            }

            if (priceToLastTransactionPercentageMax !== undefined) {
                localVarQueryParameter['priceToLastTransactionPercentageMax'] = priceToLastTransactionPercentageMax;
            }

            if (highestBidToMarketPercentageMin !== undefined) {
                localVarQueryParameter['highestBidToMarketPercentageMin'] = highestBidToMarketPercentageMin;
            }

            if (highestBidToMarketPercentageMax !== undefined) {
                localVarQueryParameter['highestBidToMarketPercentageMax'] = highestBidToMarketPercentageMax;
            }

            if (maturity !== undefined) {
                localVarQueryParameter['maturity'] = maturity;
            }

            if (drinkingFromYear !== undefined) {
                localVarQueryParameter['drinkingFromYear'] = drinkingFromYear;
            }

            if (drinkingToYear !== undefined) {
                localVarQueryParameter['drinkingToYear'] = drinkingToYear;
            }

            if (hasCriticReviews !== undefined) {
                localVarQueryParameter['hasCriticReviews'] = hasCriticReviews;
            }

            if (criticScoreMin !== undefined) {
                localVarQueryParameter['criticScoreMin'] = criticScoreMin;
            }

            if (criticScoreMax !== undefined) {
                localVarQueryParameter['criticScoreMax'] = criticScoreMax;
            }

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLwinCandidates: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLwinCandidates', 'id', id)
            const localVarPath = `/api/master-products/{id}/lwin-candidates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterProductById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMasterProductById', 'id', id)
            const localVarPath = `/api/master-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterProductFilters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/master-products/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSources: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProductSources', 'id', id)
            const localVarPath = `/api/master-products/{id}/sources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {LinkLwinRequest} linkLwinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkProductToLwin: async (id: string, linkLwinRequest: LinkLwinRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('linkProductToLwin', 'id', id)
            // verify required parameter 'linkLwinRequest' is not null or undefined
            assertParamExists('linkProductToLwin', 'linkLwinRequest', linkLwinRequest)
            const localVarPath = `/api/master-products/{id}/link-lwin`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkLwinRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkProductFromLwin: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unlinkProductFromLwin', 'id', id)
            const localVarPath = `/api/master-products/{id}/unlink-lwin`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterProductControllerApi - functional programming interface
 * @export
 */
export const MasterProductControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterProductControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Pageable} pageable 
         * @param {string} [name] 
         * @param {string} [producer] 
         * @param {string} [country] 
         * @param {string} [region] 
         * @param {string} [subRegion] 
         * @param {string} [colour] 
         * @param {string} [category] 
         * @param {boolean} [hasLwin] 
         * @param {Set<string>} [sourceCodes] 
         * @param {string} [modifiedAfter] 
         * @param {string} [modifiedBefore] 
         * @param {number} [priceToMarketPercentageMin] 
         * @param {number} [priceToMarketPercentageMax] 
         * @param {number} [priceToWineSearcherPercentageMin] 
         * @param {number} [priceToWineSearcherPercentageMax] 
         * @param {number} [priceToLastTransactionPercentageMin] 
         * @param {number} [priceToLastTransactionPercentageMax] 
         * @param {number} [highestBidToMarketPercentageMin] 
         * @param {number} [highestBidToMarketPercentageMax] 
         * @param {string} [maturity] 
         * @param {number} [drinkingFromYear] 
         * @param {number} [drinkingToYear] 
         * @param {boolean} [hasCriticReviews] 
         * @param {number} [criticScoreMin] 
         * @param {number} [criticScoreMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMasterProducts(pageable: Pageable, name?: string, producer?: string, country?: string, region?: string, subRegion?: string, colour?: string, category?: string, hasLwin?: boolean, sourceCodes?: Set<string>, modifiedAfter?: string, modifiedBefore?: string, priceToMarketPercentageMin?: number, priceToMarketPercentageMax?: number, priceToWineSearcherPercentageMin?: number, priceToWineSearcherPercentageMax?: number, priceToLastTransactionPercentageMin?: number, priceToLastTransactionPercentageMax?: number, highestBidToMarketPercentageMin?: number, highestBidToMarketPercentageMax?: number, maturity?: string, drinkingFromYear?: number, drinkingToYear?: number, hasCriticReviews?: boolean, criticScoreMin?: number, criticScoreMax?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageMasterProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMasterProducts(pageable, name, producer, country, region, subRegion, colour, category, hasLwin, sourceCodes, modifiedAfter, modifiedBefore, priceToMarketPercentageMin, priceToMarketPercentageMax, priceToWineSearcherPercentageMin, priceToWineSearcherPercentageMax, priceToLastTransactionPercentageMin, priceToLastTransactionPercentageMax, highestBidToMarketPercentageMin, highestBidToMarketPercentageMax, maturity, drinkingFromYear, drinkingToYear, hasCriticReviews, criticScoreMin, criticScoreMax, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterProductControllerApi.getAllMasterProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLwinCandidates(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LwinMappingCandidate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLwinCandidates(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterProductControllerApi.getLwinCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMasterProductById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMasterProductById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterProductControllerApi.getMasterProductById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMasterProductFilters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterProductFilterValues>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMasterProductFilters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterProductControllerApi.getMasterProductFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSources(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSources(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterProductControllerApi.getProductSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {LinkLwinRequest} linkLwinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkProductToLwin(id: string, linkLwinRequest: LinkLwinRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkLwinResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkProductToLwin(id, linkLwinRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterProductControllerApi.linkProductToLwin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkProductFromLwin(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkLwinResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkProductFromLwin(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterProductControllerApi.unlinkProductFromLwin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MasterProductControllerApi - factory interface
 * @export
 */
export const MasterProductControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterProductControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Pageable} pageable 
         * @param {string} [name] 
         * @param {string} [producer] 
         * @param {string} [country] 
         * @param {string} [region] 
         * @param {string} [subRegion] 
         * @param {string} [colour] 
         * @param {string} [category] 
         * @param {boolean} [hasLwin] 
         * @param {Set<string>} [sourceCodes] 
         * @param {string} [modifiedAfter] 
         * @param {string} [modifiedBefore] 
         * @param {number} [priceToMarketPercentageMin] 
         * @param {number} [priceToMarketPercentageMax] 
         * @param {number} [priceToWineSearcherPercentageMin] 
         * @param {number} [priceToWineSearcherPercentageMax] 
         * @param {number} [priceToLastTransactionPercentageMin] 
         * @param {number} [priceToLastTransactionPercentageMax] 
         * @param {number} [highestBidToMarketPercentageMin] 
         * @param {number} [highestBidToMarketPercentageMax] 
         * @param {string} [maturity] 
         * @param {number} [drinkingFromYear] 
         * @param {number} [drinkingToYear] 
         * @param {boolean} [hasCriticReviews] 
         * @param {number} [criticScoreMin] 
         * @param {number} [criticScoreMax] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMasterProducts(pageable: Pageable, name?: string, producer?: string, country?: string, region?: string, subRegion?: string, colour?: string, category?: string, hasLwin?: boolean, sourceCodes?: Set<string>, modifiedAfter?: string, modifiedBefore?: string, priceToMarketPercentageMin?: number, priceToMarketPercentageMax?: number, priceToWineSearcherPercentageMin?: number, priceToWineSearcherPercentageMax?: number, priceToLastTransactionPercentageMin?: number, priceToLastTransactionPercentageMax?: number, highestBidToMarketPercentageMin?: number, highestBidToMarketPercentageMax?: number, maturity?: string, drinkingFromYear?: number, drinkingToYear?: number, hasCriticReviews?: boolean, criticScoreMin?: number, criticScoreMax?: number, options?: RawAxiosRequestConfig): AxiosPromise<PageMasterProduct> {
            return localVarFp.getAllMasterProducts(pageable, name, producer, country, region, subRegion, colour, category, hasLwin, sourceCodes, modifiedAfter, modifiedBefore, priceToMarketPercentageMin, priceToMarketPercentageMax, priceToWineSearcherPercentageMin, priceToWineSearcherPercentageMax, priceToLastTransactionPercentageMin, priceToLastTransactionPercentageMax, highestBidToMarketPercentageMin, highestBidToMarketPercentageMax, maturity, drinkingFromYear, drinkingToYear, hasCriticReviews, criticScoreMin, criticScoreMax, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLwinCandidates(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<LwinMappingCandidate>> {
            return localVarFp.getLwinCandidates(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterProductById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MasterProduct> {
            return localVarFp.getMasterProductById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMasterProductFilters(options?: RawAxiosRequestConfig): AxiosPromise<MasterProductFilterValues> {
            return localVarFp.getMasterProductFilters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSources(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceInfo>> {
            return localVarFp.getProductSources(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {LinkLwinRequest} linkLwinRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkProductToLwin(id: string, linkLwinRequest: LinkLwinRequest, options?: RawAxiosRequestConfig): AxiosPromise<LinkLwinResponse> {
            return localVarFp.linkProductToLwin(id, linkLwinRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkProductFromLwin(id: string, options?: RawAxiosRequestConfig): AxiosPromise<LinkLwinResponse> {
            return localVarFp.unlinkProductFromLwin(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterProductControllerApi - object-oriented interface
 * @export
 * @class MasterProductControllerApi
 * @extends {BaseAPI}
 */
export class MasterProductControllerApi extends BaseAPI {
    /**
     * 
     * @param {Pageable} pageable 
     * @param {string} [name] 
     * @param {string} [producer] 
     * @param {string} [country] 
     * @param {string} [region] 
     * @param {string} [subRegion] 
     * @param {string} [colour] 
     * @param {string} [category] 
     * @param {boolean} [hasLwin] 
     * @param {Set<string>} [sourceCodes] 
     * @param {string} [modifiedAfter] 
     * @param {string} [modifiedBefore] 
     * @param {number} [priceToMarketPercentageMin] 
     * @param {number} [priceToMarketPercentageMax] 
     * @param {number} [priceToWineSearcherPercentageMin] 
     * @param {number} [priceToWineSearcherPercentageMax] 
     * @param {number} [priceToLastTransactionPercentageMin] 
     * @param {number} [priceToLastTransactionPercentageMax] 
     * @param {number} [highestBidToMarketPercentageMin] 
     * @param {number} [highestBidToMarketPercentageMax] 
     * @param {string} [maturity] 
     * @param {number} [drinkingFromYear] 
     * @param {number} [drinkingToYear] 
     * @param {boolean} [hasCriticReviews] 
     * @param {number} [criticScoreMin] 
     * @param {number} [criticScoreMax] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterProductControllerApi
     */
    public getAllMasterProducts(pageable: Pageable, name?: string, producer?: string, country?: string, region?: string, subRegion?: string, colour?: string, category?: string, hasLwin?: boolean, sourceCodes?: Set<string>, modifiedAfter?: string, modifiedBefore?: string, priceToMarketPercentageMin?: number, priceToMarketPercentageMax?: number, priceToWineSearcherPercentageMin?: number, priceToWineSearcherPercentageMax?: number, priceToLastTransactionPercentageMin?: number, priceToLastTransactionPercentageMax?: number, highestBidToMarketPercentageMin?: number, highestBidToMarketPercentageMax?: number, maturity?: string, drinkingFromYear?: number, drinkingToYear?: number, hasCriticReviews?: boolean, criticScoreMin?: number, criticScoreMax?: number, options?: RawAxiosRequestConfig) {
        return MasterProductControllerApiFp(this.configuration).getAllMasterProducts(pageable, name, producer, country, region, subRegion, colour, category, hasLwin, sourceCodes, modifiedAfter, modifiedBefore, priceToMarketPercentageMin, priceToMarketPercentageMax, priceToWineSearcherPercentageMin, priceToWineSearcherPercentageMax, priceToLastTransactionPercentageMin, priceToLastTransactionPercentageMax, highestBidToMarketPercentageMin, highestBidToMarketPercentageMax, maturity, drinkingFromYear, drinkingToYear, hasCriticReviews, criticScoreMin, criticScoreMax, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterProductControllerApi
     */
    public getLwinCandidates(id: string, options?: RawAxiosRequestConfig) {
        return MasterProductControllerApiFp(this.configuration).getLwinCandidates(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterProductControllerApi
     */
    public getMasterProductById(id: string, options?: RawAxiosRequestConfig) {
        return MasterProductControllerApiFp(this.configuration).getMasterProductById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterProductControllerApi
     */
    public getMasterProductFilters(options?: RawAxiosRequestConfig) {
        return MasterProductControllerApiFp(this.configuration).getMasterProductFilters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterProductControllerApi
     */
    public getProductSources(id: string, options?: RawAxiosRequestConfig) {
        return MasterProductControllerApiFp(this.configuration).getProductSources(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {LinkLwinRequest} linkLwinRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterProductControllerApi
     */
    public linkProductToLwin(id: string, linkLwinRequest: LinkLwinRequest, options?: RawAxiosRequestConfig) {
        return MasterProductControllerApiFp(this.configuration).linkProductToLwin(id, linkLwinRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterProductControllerApi
     */
    public unlinkProductFromLwin(id: string, options?: RawAxiosRequestConfig) {
        return MasterProductControllerApiFp(this.configuration).unlinkProductFromLwin(id, options).then((request) => request(this.axios, this.basePath));
    }
}



